
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import {
  addCardProductAccount,
  getCardAccountProductList,
  getCardAccountBalanceList,
  getCardAccount
} from '@/api/product/cardAccount'
import { getProductList } from '@/api/product/product'
import { PermissionModule } from '@/store/modules/permission'

@Component({
  name: 'editCardAccount',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any
  private manager: string = PermissionModule.manager

  private activeName: any = '1'
  private queryForm: any = {
    product_account_ids: []
  }
  private balanceForm: any = {
    in_or_out: null,
    balance: ''
  }

  private flag: boolean = false
  private managerList: any = []
  private productList: any = []
  private balanceList: any = []
  private listLoading: boolean = false
  private total = 0
  private balanceTotal = 0

  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  private addCardVisible: boolean = false
  private addCardAccount() {
    this.addCardVisible = true
  }
  private closeProductAccount() {
    this.addCardVisible = false
    this.queryForm.product_account_ids = []
  }
  private async addProductAccount() {
    let data = {
      product_account_ids: this.queryForm.product_account_ids,
      id: this.info.id
    }
    await addCardProductAccount(data).then(() => {
      this.$message({
        message: 'Create successful!',
        type: 'success'
      })
      this.closeProductAccount()
      this.getCardAccountList()
      this.getCardAccount()
    })
  }

  private balanceVisible: boolean = false
  private addBalance() {
    this.balanceVisible = true
  }
  private closeBalance() {
    this.balanceVisible = false
    this.balanceForm = {
      in_or_out: null,
      balance: ''
    }
  }
  private async changeBalance() {
    let data = {
      ...this.balanceForm,
      id: this.info.id
    }
    await addCardProductAccount(data).then(() => {
      this.$message({
        message: 'Create successful!',
        type: 'success'
      })
      this.getBalanceList()
      this.closeBalance()
    })
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.getCardAccountList()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.getCardAccountList()
  }

  // 获取卡商产品账户列表
  private async getCardAccountList() {
    this.listLoading = true
    const data = {
      account_no: this.queryForm.account_no,
      id: this.info.id,
      page_size: this.pagesize,
      page: this.currentPage
    }
    await getCardAccountProductList(data)
      .then((res: any) => {
        this.total = res.count
        this.managerList = res.results
        this.listLoading = false
      })
      .catch(() => {
        this.listLoading = false
      })
  }

  private select() {
    this.currentPage = 1
    this.getCardAccountList()
  }

  private reset() {
    this.currentPage = 1
    this.getCardAccountList()
  }

  // 余额分页器设置
  private balancePagesize: number = 0
  private balanceSizeChange(size) {
    this.balancePagesize = size
    this.getBalanceList()
  }

  // 余额分页切换
  private balancePage: number = 1
  private balanceCurrentChange(currentPage) {
    this.balancePage = currentPage
    this.getBalanceList()
  }
  // 余额列表
  private async getBalanceList() {
    this.listLoading = true
    const data = {
      id: this.info.id,
      page_size: this.balancePagesize,
      page: this.balancePage
    }
    await getCardAccountBalanceList(data)
      .then((res: any) => {
        this.balanceTotal = res.count
        this.balanceList = res.results
        this.listLoading = false
      })
      .catch(() => {
        this.listLoading = false
      })
  }

  // 关联产品账户列表
  private getCardAccount() {
    getCardAccount({ id: this.info.id }).then((res: any) => {
      this.productList = res
    })
  }

  private editForm: any = {
    name: this.info.name
  }
  private async editFormsSave() {
    let data = {
      name: this.editForm.name,
      id: this.info.id
    }
    await addCardProductAccount(data).then(() => {
      this.$message({
        message: 'Edit successful!',
        type: 'success'
      })
    })
  }

  mounted() {
    this.getCardAccountList()
    this.getBalanceList()
    this.getCardAccount()
  }
}
